import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
})

interface IAiProductFeatureProps{ 
  productId: string;
  featureId: string;
  role: string;
}

export const postAiProductFeature = async ({productId, featureId, role}: IAiProductFeatureProps) => {
  let token = localStorage.getItem('token')
  if(token) token = JSON.parse(token)

  try {
    const { data } = await api.post(`/ai/product/${productId}/feature/${featureId}/group`, {role},
    {
      headers: {
        'Authorization': `Bearer ${token}` 
      }
    })
    return data
  } catch (err) {
    return {error: err, msg: 'Tente novamente mais tarde!'}
  }
}